import { z } from 'zod';
import i18n from '@/shared/i18n/i18n';

const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+[\]{};':"|,.<>?]).{8,}$/;

const forgotPasswordSchema = z.object({
  email: z
    .string()
    .nonempty(i18n.t('forgotPassword.errors.email'))
    .email(i18n.t('forgotPassword.errors.emailFormat')),
});

const resetPasswordSchema = z
  .object({
    password: z
      .string()
      .nonempty(i18n.t('resetPassword.errors.password'))
      .regex(passwordRegex, i18n.t('resetPassword.errors.format')),
    confirmPassword: z
      .string()
      .nonempty(i18n.t('resetPassword.errors.passwordConfirm')),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: i18n.t('resetPassword.errors.passwordMatch'),
    path: ['confirmPassword'],
  });

type ForgotPasswordFormValues = z.infer<typeof forgotPasswordSchema>;

type ResetPasswordFormValues = z.infer<typeof resetPasswordSchema>;

export {
  forgotPasswordSchema,
  resetPasswordSchema,
  type ForgotPasswordFormValues,
  type ResetPasswordFormValues,
};
